import React from 'react'
import { Modal } from 'react-bootstrap';
import {useNavigate} from "react-router-dom";


const CheckMailBox = ({ show }) => {

  const navigate = useNavigate();


  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      className="all-modal checkMailBox"
    >
      <Modal.Body>
        <div className='box-checkMail'>
          <h1 className='title'>CHECK YOUR MAILBOX</h1>
          <p>we sent the sign in data to your mailbox, please check it out to be able to sign in normally and keep these data at safe place to use later</p>
          <button className='btn-blue w-100' onClick={() => navigate('/login')}>ok</button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default CheckMailBox